// apiConfig.js
import axios from "axios";
// You can have different base URLs for each microservice
export const API_BASES = {
    // ENQUIRY: "http://localhost:9000/enquiry-service/Enquiry/api/enquiries",
    // CUSTOMER: "http://localhost:9000/customer-service/Customer/api/customers",
    // PRODUCT: "http://localhost:9000/product-service/Product/api/master",
    // OFFER: "http://localhost:9000/offer-service/Offer/api/offers",
    // PRICE: "http://localhost:9000/price-service/Price/api/prices",
    // ORDER: "http://localhost:9000/order-service/Order/api/orders",
    // INVOICE: "http://localhost:9000/invoice-service/Invoice/api/invoices",
    // PAYMENT: "http://localhost:9000/payment-service/Payment/api/payments",
    // UPLOADFILE: "http://localhost:9000/uploadfile-service/UploadFile/api/uploads",
    // DATAUPLOAD: "http://localhost:9000/dataupload-service/DataUpload/api/datauploads",
    // INVENTORY: "http://localhost:9000/inventory-service/Inventory/api/inventories",
    // USER: "http://localhost:9000/user-service/User/api/User",
    // ADMIN: "http://localhost:9000/admin-service/Admin/api/admins",
    // REPORT: "http://localhost:9000/report-service/Report/api/reports",
    // AUTH: "http://localhost:9000/api/Auth",

    ENQUIRY: "/api/enquiries",
    CUSTOMER: "/api/customers",
    PRODUCT: "/api/master",
    OFFER: "/api/offers",
    PRICE: "/api/prices",
    ORDER: "/api/orders",
    INVOICE: "/api/invoices",
    PAYMENT: "/api/payments",
    UPLOADFILE: "/api/uploads",
    DATAUPLOAD: "/api/datauploads",
    INVENTORY: "/api/inventories",
    USER: "/api/User",
    ADMIN: "/api/admins",
    REPORT: "/api/reports",
    AUTH: "/api/Auth",
};

// (optional) Create axios instances for each base URL


export const axiosInstances = {
    enquiryApi: axios.create({ baseURL: API_BASES.ENQUIRY }),
    customerApi: axios.create({ baseURL: API_BASES.CUSTOMER }),
    productApi: axios.create({ baseURL: API_BASES.PRODUCT }),
    offerApi: axios.create({baseURL: API_BASES.OFFER}),
    priceApi: axios.create({baseURL: API_BASES.PRICE}),
    orderApi: axios.create({ baseURL: API_BASES.ORDER }),
    invoiceApi: axios.create({ baseURL: API_BASES.INVOICE }),
    paymentApi: axios.create({baseURL: API_BASES.PAYMENT}),
    uploadfileAPI: axios.create({baseURL: API_BASES.UPLOADFILE}),
    datauploadApi: axios.create({baseURL: API_BASES.DATAUPLOAD}),
    inventoryApi: axios.create({baseURL: API_BASES.INVENTORY}),
    userApi: axios.create({baseURL: API_BASES.USER}),
    adminApi: axios.create({baseURL: API_BASES.ADMIN}),
    reportApi: axios.create({baseURL: API_BASES.REPORT}),
    authApi: axios.create({ baseURL: API_BASES.AUTH }),
};
